/**
 * Spine (kernel-native: the kernel is the system of record; no coreBOS module yet).
 * Sites, buildings, rooms (coreBOS PhysicalAreas exists but was never harvested; candidate SoR). Assets sit in locations; worker groups work at locations.
 * Hand-written (ADR-029 §4); links to other spines are graph edges, see src/spines.ts.
 */
export const locationDescriptor = {
    slug: 'cmp_location',
    kind: 'document',
    label: { singular: 'Luogo', plural: 'Luoghi' },
    table: 'compliance_location',
    idStrategy: 'sha256',
    fields: [
        { name: 'name', type: 'text', label: 'Nome', required: true },
        { name: 'kind', type: 'text', label: 'Tipo' },
        { name: 'address', type: 'text', label: 'Indirizzo' },
    ],
    relations: [
        { name: 'organisation', kind: 'belongsTo', target: 'account', toEntitySpine: true },
        { name: 'parent', kind: 'belongsTo', target: 'cmp_location' },
    ],
    behaviors: { audit: true, softDelete: true, tenantScoped: true },
    ui: { mode: 'generated', icon: 'EnvironmentOutlined', navGroup: 'Organizzazione' },
};
